<template>
	<div class="row-item">
		<field-checkbox
			v-model:checked="model.enabled"
			:name="enabledName"
			:disabled="disabled"
			:indeterminate="checkboxIndeterminate"
			:aria-label="'media-crop-checkbox'"
		></field-checkbox>
	</div>
	<div class="row-item">
		<div class="field-row">
			<field-regular
				:label="t('field.appearance.mediaSize')"
				:aria-label="'media-size'"
				:label-inline="true"
				:field-classname="'field--w-38 field--w-50:desktop'"
				:field-item-grow="false"
				:unit="'%'"
				:numbers-only="true"
				v-model:model-value="model.size"
				:disabled="disabled"
			></field-regular>
			<field-regular
				:label="t('field.appearance.opacity')"
				:aria-label="'media-opacity'"
				:label-inline="true"
				:field-classname="'field--w-38 field--w-50:desktop'"
				:field-item-grow="false"
				:unit="'%'"
				:numbers-only="true"
				v-model:model-value="model.opacity"
				:disabled="disabled"
			></field-regular>
		</div>
	</div>
</template>

<script>
import FieldCheckbox from '@/components/fields/FieldCheckbox';
import FieldRegular from '@/components/fields/FieldRegular';
import {computed, reactive} from 'vue';
import {useI18n} from 'vue-i18n';
export default {
	components: {
		FieldCheckbox,
		FieldRegular
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		enabled: {
			type: Boolean,
		},
		enabledName: {
			type: String,
		},
		checkboxIndeterminate: {
			type: Boolean,
			default: false
		},
		size: {
			type: Number,
		},
		opacity: {
			type: Number
		}
	},
	setup(props, {emit}) {
		const {t} = useI18n();
		const modelEnabled = computed({
			get(){return props.enabled},
			set(value){emit('update:enabled', value)}
		})
		const modelSize = computed({
			get(){return props.size},
			set(value){emit('update:size', value)}
		})
		const modelOpacity = computed({
			get(){return props.opacity},
			set(value){emit('update:opacity', value)}
		})
		
		const model = reactive({
			enabled: modelEnabled,
			size: modelSize,
			opacity: modelOpacity
		})
		
		return {
			t,
			model
		}
	}
}
</script>

<style lang="scss">

</style>
